import OrderStatusSkeleton from './OrderStatusSkeleton'

export default OrderStatusSkeleton
